import { SPOTLIGHT, waLink } from "../data/catalogue";
import { Reveal, WhatsAppIcon } from "./Shared";

const productMsg = (label) =>
  `Hi Anubandh! I'd love to know the price of "${label}", sharing a screenshot on WhatsApp.`;

export default function Spotlight() {
  return (
    <section
      id="spotlight"
      data-testid="spotlight-section"
      className="scroll-mt-24 py-20 sm:py-28 bg-parchment/50 border-y border-sand"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <Reveal>
            <p className="text-xs font-semibold uppercase tracking-[0.24em] text-coral">
              Straight from the catalogues
            </p>
            <h2 className="mt-4 font-serif font-medium tracking-tight text-ink text-4xl sm:text-5xl">
              A peek at what&apos;s inside<span className="text-sage">.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="max-w-sm text-sm leading-relaxed text-cocoa md:text-right">
              Screenshots are welcome here. Send us your favourites on WhatsApp and
              we&apos;ll quote the moment we see them.
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-12 gap-5">
          {SPOTLIGHT.map((p, i) => (
            <Reveal
              key={p.id}
              delay={(i % 3) * 0.1}
              className={`${p.span} col-span-1`}
            >
              <a
                href={waLink(productMsg(p.label))}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`spotlight-product-${p.id}`}
                className={`group relative block w-full overflow-hidden rounded-[1.75rem] ${p.h}`}
              >
                <img
                  src={p.img}
                  alt={`${p.label}, ${p.note}`}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.05]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-espresso/70 via-espresso/0 to-espresso/0 opacity-80 transition-opacity duration-500 group-hover:opacity-95" />
                <div className="absolute inset-x-0 bottom-0 flex items-end justify-between gap-3 p-6">
                  <div>
                    <p className="font-serif text-xl sm:text-2xl font-medium text-cream">
                      {p.label}
                    </p>
                    <p className="mt-1 text-xs font-medium uppercase tracking-[0.18em] text-cream/70">
                      {p.note}
                    </p>
                  </div>
                  <span className="inline-flex items-center gap-2 rounded-full bg-cream/95 px-4 py-2 text-xs font-semibold text-ink opacity-0 translate-y-2 transition-all duration-500 group-hover:opacity-100 group-hover:translate-y-0">
                    <WhatsAppIcon className="h-3.5 w-3.5 text-sage-deep" />
                    Screenshot &amp; ask price
                  </span>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
